/**
 * Copyright 2025 Phenix Real Time Solutions, Inc. Confidential and Proprietary. All Rights Reserved.
 */

const resolutions = [
  {
    name: '1080p',
    value: 1080,
    compatibleQualities: ['uhd', 'fhd', 'xhd'],
    index: 3
  },
  {
    name: '720p',
    value: 720,
    compatibleQualities: ['uhd', 'fhd', 'xhd', 'hd'],
    index: 4
  },
  {
    name: '480p',
    value: 480,
    compatibleQualities: ['uhd', 'fhd', 'xhd', 'hd', 'sd'],
    index: 5
  },
  {
    name: '360p',
    value: 360,
    compatibleQualities: ['uhd', 'fhd', 'xhd', 'hd', 'sd', 'ld'],
    index: 6
  },
  {
    name: '240p',
    value: 240,
    compatibleQualities: ['uhd', 'fhd', 'xhd', 'hd', 'sd', 'ld', 'vld'],
    index: 7
  },
  {
    name: '144p',
    value: 144,
    compatibleQualities: ['uhd', 'fhd', 'xhd', 'hd', 'sd', 'ld', 'vld', 'vvld', 'uld'],
    index: 8
  }
];
const experimentalResolutions = [
  {
    name: '2160p',
    value: 2160,
    compatibleQualities: ['uhd', 'fhd', 'xhd', 'hd', 'sd', 'ld', 'vld', 'uld'],
    index: 1
  },
  {
    name: '1080p XHD',
    value: '1080xhd',
    compatibleQualities: ['uhd', 'fhd', 'xhd', 'hd', 'sd', 'ld', 'vld', 'uld'],
    index: 2
  }
];

export {resolutions, experimentalResolutions};